export default __webpack_public_path__ + "static/media/twitter-logo.a8a75254.svg";